// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__xFl9i","title":"Banner_title__1wKVY","titleText":"Banner_titleText__BkPP8","closeButton":"Banner_closeButton__f6bMh"};